import { createContext } from "react";
import { GuestAppStore, PrivateAppStore, PublicAppStore } from "@/store";

export const AppStoreContext = createContext<PrivateAppStore | null>(null);
export const PublicAppStoreContext = createContext<PublicAppStore | null>(null);
export const GuestAppStoreContext = createContext<GuestAppStore | null>(null);
